import React from 'react';
import { Link } from 'react-router-dom';

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-[#FAFAFA]">
      <div className="bg-[#FFF8F5] py-12">
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          <h1 className="font-heading text-3xl md:text-4xl font-black text-slate-900">Condizioni di Vendita</h1>
          <p className="text-slate-500 mt-2">Ai sensi del D.Lgs. 206/2005 (Codice del Consumo)</p>
        </div>
      </div>
      <div className="max-w-4xl mx-auto px-6 md:px-12 py-12 prose prose-slate max-w-none">
        <p className="text-sm text-slate-500 mb-8">Ultimo aggiornamento: {new Date().toLocaleDateString('it-IT')}</p>

        <h2 className="font-heading text-xl font-bold text-slate-900">1. Identificazione del Venditore</h2>
        <p><strong>A.S.D. Caribbean Blue Moon Dance School</strong><br/>
        Sede legale: Via Ambra 19, 58100 Grosseto (GR), Italia<br/>
        P.IVA: 01770860532<br/>
        Email/PEC: <a href="mailto:caribbean.bluemoon2025@gmail.com" className="text-[#0288D1]">caribbean.bluemoon2025@gmail.com</a><br/>
        Telefono: 380 159 9564</p>

        <h2 className="font-heading text-xl font-bold text-slate-900 mt-8">2. Prodotti e Prezzi</h2>
        <p>I prezzi indicati sul sito sono espressi in Euro (EUR) e sono comprensivi di IVA ove applicabile. Il venditore si riserva il diritto di modificare i prezzi in qualsiasi momento, senza preavviso. Il prezzo applicato sarà quello vigente al momento dell'ordine.</p>

        <h2 className="font-heading text-xl font-bold text-slate-900 mt-8">3. Modalità di Pagamento</h2>
        <p>Sono accettate le seguenti modalità di pagamento:</p>
        <ul className="list-disc pl-6 space-y-1 text-slate-600">
          <li><strong>Carta di credito / Postepay:</strong> tramite piattaforma sicura Stripe (PCI-DSS compliant)</li>
          <li><strong>Bonifico bancario:</strong> Banca BPM - IBAN: IT82E0503414302000000011922, intestato a A.S.D. Caribbean Blue Moon Dance School</li>
        </ul>
        <p>Per pagamenti con bonifico, l'ordine sarà processato dopo la ricezione del pagamento.</p>

        <h2 className="font-heading text-xl font-bold text-slate-900 mt-8">4. Spedizioni</h2>
        <p>I tempi e i costi di spedizione verranno comunicati al momento dell'ordine. Le spedizioni avvengono su tutto il territorio nazionale.</p>

        <h2 className="font-heading text-xl font-bold text-slate-900 mt-8">5. Diritto di Recesso</h2>
        <p>Ai sensi degli artt. 52-59 del D.Lgs. 206/2005 (Codice del Consumo), il consumatore ha diritto di recedere dal contratto entro <strong>14 giorni</strong> dalla ricezione del prodotto, senza dover fornire alcuna motivazione.</p>
        <p>Per esercitare il diritto di recesso:</p>
        <ul className="list-disc pl-6 space-y-1 text-slate-600">
          <li>Inviare comunicazione scritta a <a href="mailto:caribbeanbluemoon2025@gmail.com" className="text-[#0288D1]">caribbeanbluemoon2025@gmail.com</a></li>
          <li>Restituire il prodotto integro, nella confezione originale, entro 14 giorni dalla comunicazione</li>
          <li>Le spese di restituzione sono a carico del consumatore</li>
          <li>Il rimborso sarà effettuato entro 14 giorni dal ricevimento del reso, con lo stesso metodo di pagamento utilizzato</li>
        </ul>

        <h2 className="font-heading text-xl font-bold text-slate-900 mt-8">6. Garanzia Legale</h2>
        <p>Tutti i prodotti sono coperti dalla <strong>garanzia legale di conformità</strong> di 24 mesi ai sensi degli artt. 128-135 del Codice del Consumo. In caso di difetto di conformità, il consumatore ha diritto alla riparazione o sostituzione del prodotto, oppure alla riduzione del prezzo o risoluzione del contratto.</p>

        <h2 className="font-heading text-xl font-bold text-slate-900 mt-8">7. Lezioni di Prova</h2>
        <p>Le lezioni di prova sono gratuite e non vincolanti. La richiesta di prenotazione non costituisce obbligo di iscrizione ai corsi.</p>

        <h2 className="font-heading text-xl font-bold text-slate-900 mt-8">8. Affitto Sala</h2>
        <p>I prezzi per l'affitto della sala vengono concordati direttamente con il cliente. La richiesta tramite il modulo online non è vincolante e non costituisce prenotazione confermata.</p>

        <h2 className="font-heading text-xl font-bold text-slate-900 mt-8">9. Foro Competente</h2>
        <p>Per qualsiasi controversia relativa all'interpretazione o esecuzione delle presenti condizioni, sarà competente il Foro del luogo di residenza del consumatore, ai sensi dell'art. 66-bis del Codice del Consumo.</p>

        <h2 className="font-heading text-xl font-bold text-slate-900 mt-8">10. Risoluzione Online delle Controversie (ODR)</h2>
        <p>Ai sensi del Regolamento UE 524/2013, il consumatore può avvalersi della piattaforma ODR per la risoluzione extragiudiziale delle controversie: <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" className="text-[#0288D1]">https://ec.europa.eu/consumers/odr</a></p>

        <div className="mt-12 pt-8 border-t border-slate-200">
          <Link to="/" className="text-[#0288D1] font-heading font-semibold hover:text-[#FF7043] transition-colors">
            ← Torna alla Home
          </Link>
        </div>
      </div>
    </div>
  );
}
